import {
  DownloadOutlined,
  Payment,
  PreviewOutlined,
} from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import { downloadReceipt } from "api/services/billing/receipts";
import { snack } from "components/toast";
import { useMutation, useQueryClient } from "react-query";
import { handleError } from "utils/handleError";
import { StyledActionsMenu } from "../styles";

interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: (anchorEl: HTMLElement | null) => void;
  selected: any[];
  clearSelection: () => void;
}

const Actions = (props: Props) => {
  const { anchorEl, setAnchorEl, selected, clearSelection } = props;

  const { mutate, isLoading } = useMutation(downloadReceipt, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], { type: "application/pdf" });
      const pdf = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = pdf;
      link.download = `${selected[0]?.client?.tradeName || selected[0]?.client?.displayName} - ${selected[0]?.receiptNumber}.pdf`;
      link.click();
    },
    onError: (err: any) => {
      snack.error(handleError(err));
    },
  });

  const handlePriview = () => {
    window.open(`/billing/receipts/${selected[0]?.id}/preview`);
  };

  const handleDownload = () => {
    mutate({ id: selected[0]?.id });
  };

  return (
    <>
      <StyledActionsMenu
        anchorEl={anchorEl}
        onClick={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
          <MenuItem
            disabled={
              selected.length !== 1
            }
            onClick={handlePriview}
          >
            <PreviewOutlined />
            Preview
          </MenuItem>
          <MenuItem
            onClick={handleDownload}
            disabled={
              selected.length !== 1 ||
              isLoading
            }
          >
            <DownloadOutlined />
            Download Receipt
          </MenuItem>
      </StyledActionsMenu>
    </>
  );
};

export default Actions;
